import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Url } from "../url";
import axios from "axios";

export const fetchThanksData = createAsyncThunk(
  "thanksData/fetchThanksData",
  async (
    { confirmationNumber, chainCode, language = "en" },
    rejectWithValue
  ) => {
    try {
      const response = await axios.get(
        `${Url}/Booking/${language}/confirmation/${confirmationNumber}?chainCode=${chainCode}`
      );
      return response.data; // Assuming the API response format is { data: [...] }
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
const ThanksData = createSlice({
  name: "thanksData",
  initialState: {
    thanksData: [],
    loadings: false,
    errors: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchThanksData.pending, (state) => {
        state.loadings = true;
      })
      .addCase(fetchThanksData.fulfilled, (state, action) => {
        state.loadings = false;
        state.thanksData = action.payload;
      })
      .addCase(fetchThanksData.rejected, (state, action) => {
        state.loadings = false;
        state.errors = action.error.message;
      });
  },
});

export default ThanksData.reducer;
